import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Sell.css";

function Sell() {

  const [sellData, setSellData] = useState([]);
  const [imageIndex, setImageIndex] = useState({});
  const navigate = useNavigate();

  useEffect(() => {

  fetch("https://urbanbrick.in.net/get-properties.php")
    .then(res => res.json())
    .then(data => {

      const sellFiltered = data.filter(
        (item) => item.listingType === "Sell"
      );

      setSellData(sellFiltered);

    })
    .catch(err => console.log(err));

}, []);



  const nextImage = (id, total) => {

    setImageIndex((prev) => ({

      ...prev,

      [id]:
        (prev[id] + 1) % total || 0

    }));

  };

  // PREVIOUS IMAGE

  const prevImage = (id, total) => {

    setImageIndex((prev) => ({

      ...prev,

      [id]:
        prev[id] === 0
          ? total - 1
          : prev[id] - 1

    }));

  };

  return (

    <div className="sell-page">

      <h2 className="sell-title">
        Sell Properties
      </h2>

      <div className="sell-grid">

        {sellData.length === 0 ? (

          <p className="sell-empty">
            No Sell Properties Available
          </p>

        ) : (

          sellData.map((item) => {

            const current =
              imageIndex[item.id] || 0;

            return (

              <div
                className="sell-card"
                key={item.id}
              >

                {/* IMAGE WITH ARROWS */}

                <div className="sell-image-box">

                  <button
                    className="sell-arrow left"
                    onClick={() =>
                      prevImage(
                        item.id,
                        item.images.length
                      )
                    }
                  >
                    ❮
                  </button>

                  <img
                    src={
                      item.images?.[
                        current
                      ]
                    }
                    alt=""
                    className="sell-image"
                  />

                  <button
                    className="sell-arrow right"
                    onClick={() =>
                      nextImage(
                        item.id,
                        item.images.length
                      )
                    }
                  >
                    ❯
                  </button>

                </div>

                <div className="sell-info">

                  <h3>
                    {item.title}
                  </h3>

                  <p>
                    {item.property_type}
                  </p>

                  <p>
                    📍 {item.city}
                  </p>

                  <p>
                    ₹ {item.price}
                  </p>

                  <button
                    className="sell-button"
                    onClick={() =>
                      navigate(`/property/${item.id}`)
                    }
                  >
                    View Details
                  </button>

                </div>

              </div>

            );

          })

        )}

      </div>

    </div>

  );

}

export default Sell;